import cipher14Hint2 from '../../../../assets/images/games/zdar-escape-game/ciphers/14/hint2.webp';
import cipher14Image from '../../../../assets/images/games/zdar-escape-game/ciphers/14/plan.webp';

const hints = [
    {
        text: 'Jedná se o dětské hřiště v parku, je úplně dole.',
    },
    {
        image: cipher14Hint2,
    },
];
export const step14park = {
    id: 13,
    title: '6. stanoviště',
    taskText: `
        <p>
            Fuška co? Ale tak máme to. Výměnou za nalezení hvězdy ti prý poslal obrázek. Co myslíš? Podle mě musíme přijít na to, kudy se tím koukáme a tam vyrazit. 
        </p>
        <p>    
            Nikdy jsem vojáky neměl rád, jsou samá hádanka. Hmm kde by to mohlo být? Pojďme pořád za nosem, to nikdy ničemu neuškodilo. Možná budeme muset jít až na druhý konec parku, myslím, že tam bylo nějaké hřiště. Támhle, jdeme.
        </p>
    `,
    catImage: 6,
    cipher: {
        label: 'Úkol',
        images: [cipher14Image],
    },
    continueButtonText: 'Dále',
    hints: hints,
    snowHints: hints,
};
